/**
 * Generic loader display for validating/executing phases of the import modal.
 *
 * Extracted from ImportModal.tsx (Sub-PR 6.4).
 */

import { Loader2 } from 'lucide-react'

interface PhaseLoaderProps {
  message: string
}

export function PhaseLoader({ message }: PhaseLoaderProps): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="h-12 w-12 animate-spin text-blue-500" />
      <p className="mt-4 text-slate-600 dark:text-slate-400">{message}</p>
    </div>
  )
}
